var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.341 3.812C17.466 2.917 16.904 2 16.001 2 8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14c0-1.392-1.482-2.157-2.867-2.02A8.974 8.974 0 0 1 17.34 3.81zm4.224 12.368a5.744 5.744 0 1 1-11.487 0 5.744 5.744 0 0 1 11.487 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBake);
export default __webpack_public_path__ + "static/media/BAKE.1148b53e4ed8bad7504d832da1cd435b.svg";
export { ForwardRef as ReactComponent };